(function () {
  "use strict";

  const VERSION = "0.4.0";
  const { formatAddress, getAccountUrls } = window.QB?.customerData || {};

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function buildGuestHtml(urls) {
    return `
      <div class="qb-account qb-account--guest">
        <p class="qb-account__message">Sign in to manage your account, view orders, and track rewards.</p>
        <a class="qb-account__btn" href="${escapeHtml(window.QB?.loginUrl?.("account") || urls.login)}">Sign in</a>
        <a class="qb-account__link" href="${escapeHtml(urls.register)}">Create account</a>
      </div>
    `;
  }

  function buildLoadingHtml() {
    return `
      <div class="qb-account qb-account--loading" aria-live="polite">
        <p class="qb-slot__loading">Loading account…</p>
      </div>
    `;
  }

  function buildErrorHtml(message) {
    return `
      <div class="qb-account qb-account--error" role="alert">
        <p class="qb-slot__error">${escapeHtml(message)}</p>
        <button type="button" class="qb-account__btn qb-account__btn--secondary" data-qb-retry>Try again</button>
      </div>
    `;
  }

  function buildAddressCards(addresses) {
    if (!addresses.length) {
      return `<p class="qb-account__empty">No saved addresses yet.</p>`;
    }

    return addresses
      .map((address) => {
        const formatted = formatAddress ? formatAddress(address) : "";
        const defaultBadge = address.default
          ? `<span class="qb-account__address-default">Default</span>`
          : "";
        return `
          <div class="qb-account__address-card">
            ${defaultBadge}
            <p class="qb-account__address-text">${escapeHtml(formatted)}</p>
          </div>
        `;
      })
      .join("");
  }

  function buildLoggedInHtml(data, urls) {
    const customer = window.QB?.customer || {};
    const firstName = data.firstName || customer.firstName || "";
    const lastName = data.lastName || "";
    const fullName = [firstName, lastName].filter(Boolean).join(" ") || "there";
    const email = data.email || customer.email || "";
    const tier = escapeHtml(customer.tier || "Member");

    return `
      <div class="qb-account">
        <div class="qb-account__profile">
          <p class="qb-account__name">${escapeHtml(fullName)}</p>
          ${email ? `<p class="qb-account__email">${escapeHtml(email)}</p>` : ""}
          <span class="qb-account__tier">${tier}</span>
          <a class="qb-account__btn qb-account__btn--outline" href="${escapeHtml(urls.account)}">Edit account</a>
        </div>

        <div class="qb-account__section">
          <div class="qb-account__section-head">
            <h3 class="qb-account__section-title">Shipping information</h3>
            <a class="qb-account__section-edit" href="${escapeHtml(urls.addresses)}">Edit</a>
          </div>
          <div class="qb-account__addresses">
            ${buildAddressCards(data.addresses || [])}
          </div>
        </div>

        <div class="qb-account__actions">
          <a class="qb-account__btn qb-account__btn--outline" href="${escapeHtml(urls.account)}">View account</a>
          <a class="qb-account__btn" href="${escapeHtml(urls.logout)}">Sign out</a>
        </div>
      </div>
    `;
  }

  class QBAccountSlot {
    constructor(panel) {
      this.panel = panel;
      this.loaded = false;
      this.loading = false;
      this.urls = getAccountUrls ? getAccountUrls() : {};
      this.renderShell();
    }

    renderShell() {
      const customer = window.QB?.customer;
      if (!customer?.loggedIn) {
        this.panel.innerHTML = buildGuestHtml(this.urls);
        return;
      }
      this.panel.innerHTML = buildLoadingHtml();
    }

    bindRetry() {
      this.panel.querySelector("[data-qb-retry]")?.addEventListener("click", () => {
        this.loaded = false;
        window.QB?.customerData?.clearCache?.();
        this.onActivate();
      });
    }

    async onActivate() {
      if (!window.QB?.customer?.loggedIn) return;
      if (this.loaded || this.loading) return;

      this.loading = true;
      this.panel.innerHTML = buildLoadingHtml();

      try {
        const fetchFn = window.QB?.customerData?.fetch;
        if (!fetchFn) throw new Error("customer_data_module_missing");
        const data = await fetchFn();
        this.urls = getAccountUrls ? getAccountUrls() : this.urls;
        this.panel.innerHTML = buildLoggedInHtml(data, this.urls);
        this.loaded = true;
      } catch {
        this.panel.innerHTML = buildErrorHtml("Could not load account details. Please try again.");
        this.bindRetry();
      } finally {
        this.loading = false;
      }
    }
  }

  window.QB = window.QB || {};
  window.QB.slotModules = window.QB.slotModules || {};
  window.QB.slotModules.account = {
    version: VERSION,
    init(panel) {
      return new QBAccountSlot(panel);
    },
  };
})();
